import createPlugin from './createPlugin'
import AccordionRenderer from './Renderer/AccordionRenderer'

const accordionPlugin = settings =>
    createPlugin({
        Renderer: AccordionRenderer,
        ...settings,
    })

const accordion = accordionPlugin()
export default accordion

export { accordionPlugin, AccordionRenderer }
